import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import QuestionText from '../components/QuestionText';
import Button from '../../../components/Button.js';
import { LocationInput } from '../../../components/input';
import FormControl from '@material-ui/core/FormControl';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
    margin: 0,
    backgroundColor: theme.palette.common.white,
  },
  button: {
    padding: '1.5rem 0',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ParticipantLocationQuestion = ({data, handleAnswer}) => {
  const classes = useStyles();
  const [location, setLocation] = React.useState(data.location);
  const disabled = location === '' ? true : false;
  const handleSubmit = () => {
    handleAnswer('location', location);
  };
  return (
    <React.Fragment>
      <QuestionText>
        Where is the person needing the services located?
      </QuestionText>
      <FormControl className={classes.formControl}>
        <LocationInput
          required
          onEnter={setLocation}
          value={location}
        />
      </FormControl>
      <div className={classes.button}>
        <Button
          onClick={handleSubmit}
          label="Next"
          pointer="right"
          variant="contained"
          disabled={disabled}
        />
      </div>
    </React.Fragment>
  );
};

ParticipantLocationQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default ParticipantLocationQuestion;
